<template>
	<el-menu class="navbar" mode="horizontal">
		<hamburger
			class="hamburger-container"
			:toggleClick="toggleSideBar"
			:isActive="sidebar.opened"
		></hamburger>

		<!-- <breadcrumb class="breadcrumb-container"></breadcrumb> -->
		<div class="breadcrumb-container">
			<customer></customer>
		</div>

		<div class="right-menu">
			<el-button type="text" class="right-menu-item" @click="openAiDrawer" v-if="showAdAssistant"
				>AI广告助手</el-button
			>
			<helpLink></helpLink>

			<system-switch class="right-menu-item"></system-switch>
			<!-- <error-log class="errLog-container right-menu-item"></error-log> -->

			<!-- <el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom"> -->
			<!-- <screenfull class="screenfull right-menu-item"></screenfull> -->
			<!-- </el-tooltip> -->

			<el-dropdown class="avatar-container right-menu-item" trigger="click">
				<div class="avatar-wrapper">
					<!--<img class="user-avatar" :src="avatar">-->
					<span class="user-avatar">{{ name }}</span>
					<i class="el-icon-caret-bottom"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item style="padding: 0">
						<span @click="logout" style="display: block; padding: 0 20px">退出登录</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</el-menu>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb/index';
import Hamburger from '@/components/Hamburger/index';
import customer from './customer';
import helpLink from './helpLink.vue';
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
//import LangSelect from "@/components/LangSelect";
// import ThemePicker from '@/components/ThemePicker'

export default {
	components: {
		Breadcrumb,
		Hamburger,
		customer,
		helpLink,
		// ErrorLog,
		// Screenfull,
		//    LangSelect
		// ThemePicker
	},
	computed: {
		...mapGetters(['sidebar', 'name', 'avatar']),
		...mapState({
			showDrawer: state => state.aiAds.showDrawer,
		}),
		showAdAssistant() {
			return this.getPermission('adAssistant');
		},
	},
	methods: {
		...mapMutations(['setShowDrawer']),
		openAiDrawer() {
			this.setShowDrawer();
		},
		toggleSideBar() {
			this.$store.dispatch('toggleSideBar');
		},
		logout() {
			this.$confirm('确认退出？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.$Sky.sso.checkOut(location);
				})
				.catch(() => {});

			/*this.$store.dispatch("LogOut").then(() => {
                  location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
                });*/
		},
	},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
	height: 50px;
	line-height: 50px;
	border-radius: 0px !important;
	.hamburger-container {
		line-height: 58px;
		height: 50px;
		float: left;
		padding: 0 10px;
	}
	.breadcrumb-container {
		height: 100%;
		float: left;
	}
	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}
	.right-menu {
		float: right;
		height: 100%;

		&:focus {
			outline: none;
		}
		.right-menu-item {
			display: inline-block;
			margin: 0 8px;
		}
		.username {
			vertical-align: top;
		}
		.screenfull {
			height: 20px;
		}
		.international {
			vertical-align: top;
		}
		.theme-switch {
			vertical-align: 15px;
		}
		.avatar-container {
			height: 50px;
			margin-right: 30px;
			.avatar-wrapper {
				cursor: pointer;
				margin-top: 5px;
				.user-avatar {
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}
				.el-icon-caret-bottom {
					margin-left: 4px;
					font-size: 12px;
				}
			}
		}
	}
}
</style>
